<template>
    <a-modal v-model="visible" width="900px" :title="$t('submission.add_org.title' /*添加单位*/)" :footer="null" centered @cancel="handleCancelEvent" class="modal-box">
        <a-form :form="form">
            <a-form-item class="mb10" :label="$t('submission.add_org.org_name' /*单位名称*/)">
                <a-input
                    v-decorator="['org_cnname', { rules: [{ required: true, message: $t('submission.add_org.enter_org_name' /*请输入单位名称*/) }] }]"
                    :placeholder="$t('submission.add_org.enter_org_name' /*请输入单位名称*/)"
                ></a-input>
            </a-form-item>
            <a-form-item class="mb10" :label="$t('submission.add_org.org_address' /*单位地址*/)">
                <a-input
                    v-decorator="['address', { rules: [{ required: true, message: $t('submission.add_org.enter_org_address' /*请输入单位地址*/) }] }]"
                    :placeholder="$t('submission.add_org.enter_org_address' /*请输入单位地址*/)"
                ></a-input>
            </a-form-item>
            <a-form-item class="mb10" :label="$t('submission.add_org.org_postal_code' /*单位邮编*/)">
                <a-input
                    v-decorator="['zipcode', { rules: [{ required: true, message: $t('submission.add_org.enter_org_postal_code' /*请输入单位邮编*/) }] }]"
                    :placeholder="$t('submission.add_org.enter_org_postal_code' /*请输入单位邮编*/)"
                ></a-input>
            </a-form-item>
        </a-form>
        <div class="flex x-right">
            <a-button class="mr10" @click="handleCancelEvent">{{ $t('submission.add_org.cancel' /*取消*/) }}</a-button>
            <a-button type="primary" @click="handleSubmitEvent">{{ $t('submission.add_org.submit' /*提交*/) }}</a-button>
        </div>
    </a-modal>
</template>

<script>
const fields = ['address', 'org_cnname', 'zipcode'];
import pick from 'lodash.pick';
export default {
    name: 'AbstractEdit',
    components: {},
    data() {
        return {
            form: this.$form.createForm(this),
            provinceList: [], // 省份列表
            info: {},
            visible: false
        };
    },
    computed: {},
    methods: {
        show(item) {
            this.visible = true;
            this.info = item || {};
            // 防止表单未注册
            fields.forEach(v => {
                this.form.getFieldDecorator(v);
            });
            this.$nextTick(() => {
                // 回显
                if (item) {
                    this.form.setFieldsValue(pick(this.info, fields));
                }
            });
        },
        handleSubmitEvent() {
            this.form.validateFields((error, values) => {
                if (!error) {
                    this.$request.post({ url: this.info.id ? 'updateOrgListItem' : 'addOrgListItem', data: { ...values, id: this.info.id || 0, abstract_id: this.info.abstract_id } }).then(res => {
                        this.$emit('reset');
                        this.handleCancelEvent();
                    });
                }
            });
        },
        handleCancelEvent() {
            this.form.resetFields();
            this.visible = false;
        },
        // 获取省份列表
        getProvinceList() {
            this.$store.dispatch('getAddress').then(res => {
                this.provinceList = res[42]?.list;
            });
        }
    },
    created() {},
    mounted() {
        this.getProvinceList();
    }
};
</script>
<style lang="less" scoped></style>
